import { defineMessages } from 'react-intl';

/* eslint-disable max-len */

export default defineMessages({
  serviceUser: {
    id: 'reviews.card.serviceUser',
    description: "Service's <servicename> user", // eslint-disable-line
    defaultMessage: 'Palvelun {serviceName} user',
  },
  ratingLabelOverall: {
    id: 'reviews.card.ratingLabelOverall',
    description: 'Rating label for overall',
    defaultMessage: 'Yleisarvosana',
  },
  ratingLabelPrice: {
    id: 'reviews.card.ratingLabelPrice',
    description: 'Rating label for price',
    defaultMessage: 'Vastine rahalle!',
  },
  ratingLabelQuality: {
    id: 'reviews.card.ratingLabelQuality',
    description: 'Rating label for quality',
    defaultMessage: 'Laatuarvosana',
  },
  ratingLabelThumbs: {
    id: 'reviews.card.ratingLabelThumbs',
    description: 'Rating label for thumbs',
    defaultMessage: 'Palvelun sujuvuus',
  },
  sendMessage: {
    id: 'reviews.card.sendMessage',
    description: 'Send message to user',
    defaultMessage: 'Lähetä viesti',
  },
});
